import React, { useRef, Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.3
    }
  }
};
export function WhatsInsideSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const features = [{
    title: 'The "Invisible Anchor" Technique',
    description: "Secure your vault directly into the home's skeletal structure. It can't be removed without taking the house with it."
  }, {
    title: 'The $500 Bill of Materials',
    description: "The exact list of SKUs you need from Home Depot or Lowe's. No specialty suppliers, no paper trail."
  }, {
    title: 'The Stealth-Door Secret',
    description: 'How to create a flush-mount lid that disappears under standard carpet, tile, or hardwood.'
  }, {
    title: 'Fire-Rating Mastery',
    description: 'The inexpensive drywall trick that creates a 2,000°F heat shield for your optics and ammunition.'
  }];
  return <section ref={ref} className="w-full bg-dark-bg py-20 md:py-28" data-id="element-410">
      <div className="max-w-4xl mx-auto px-6" data-id="element-411">
        {/* Headline */}
        <motion.h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-white text-center mb-16 tracking-wide" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-412">
          INSIDE THE <span className="text-orange-accent" data-id="element-413">CONCRETE BUNKER</span>{' '}
          BLUEPRINT
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-414">
          {/* Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-2 lg:order-1" data-id="element-415">
            <img src="https://cdn.magicpatterns.com/uploads/m9FhLpYcYjfj2UC1nUsn2G/heylloyd-image-1771478685936.png" alt="The Concrete Bunker Blueprint Guide" className="w-full max-w-sm mx-auto drop-shadow-2xl" data-id="element-416" />
          </motion.div>

          {/* Feature list */}
          <motion.div className="order-1 lg:order-2 space-y-6" variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-417">
            {features.map(feature => <motion.div key={feature.title} variants={itemVariants} className="flex gap-4" data-id="element-418">
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-orange-accent/20 border border-orange-accent/50" data-id="element-419">
                  <CheckIcon className="w-5 h-5 text-orange-accent" data-id="element-420" />
                </div>
                <div data-id="element-421">
                  <h3 className="font-inter font-bold text-white text-lg mb-1" data-id="element-422">
                    {feature.title}
                  </h3>
                  <p className="font-inter text-concrete leading-relaxed" data-id="element-423">
                    {feature.description}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}